module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 29);
/******/ })
/************************************************************************/
/******/ ({

/***/ 23:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime-corejs2/core-js/parse-int");

/***/ }),

/***/ 29:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "urlRegex", function() { return urlRegex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "urlHash", function() { return urlHash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "urlParams", function() { return urlParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parseUrl", function() { return parseUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateParam", function() { return updateParam; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUrlHash", function() { return getUrlHash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeParam", function() { return removeParam; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isUrl", function() { return isUrl; });
/* harmony import */ var _babel_runtime_corejs2_core_js_parse_int__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23);
/* harmony import */ var _babel_runtime_corejs2_core_js_parse_int__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_corejs2_core_js_parse_int__WEBPACK_IMPORTED_MODULE_0__);

var strRegex = '^((https|http|ftp|rtsp|mms)://)?[a-z0-9A-Z]{3}\.([a-z0-9A-Z][a-z0-9A-Z]{0,61}?[a-z0-9A-Z]\.)+com|net|cn|cc (:s[0-9]{1-4})?/$';
var urlRegex = new RegExp(strRegex); //获取当前url查询字符串参数

var urlHash = parseUrl('hash') || {};
var urlParams = parseUrl('?') || {}; //正则

function _t() {
  return new RegExp(/(.*?)\.?([^\.]*?)\.?(com|net|org|biz|ws|in|me|co\.uk|co|org\.uk|ltd\.uk|plc\.uk|me\.uk|edu|mil|br\.com|cn\.com|eu\.com|hu\.com|no\.com|qc\.com|sa\.com|se\.com|se\.net|us\.com|uy\.com|ac|co\.ac|gv\.ac|or\.ac|ac\.ac|af|am|as|at|ac\.at|co\.at|gv\.at|or\.at|asn\.au|com\.au|edu\.au|org\.au|net\.au|id\.au|be|ac\.be|adm\.br|adv\.br|am\.br|arq\.br|art\.br|bio\.br|cng\.br|cnt\.br|com\.br|ecn\.br|eng\.br|esp\.br|etc\.br|eti\.br|fm\.br|fot\.br|fst\.br|g12\.br|gov\.br|ind\.br|inf\.br|jor\.br|lel\.br|med\.br|mil\.br|net\.br|nom\.br|ntr\.br|odo\.br|org\.br|ppg\.br|pro\.br|psc\.br|psi\.br|rec\.br|slg\.br|tmp\.br|tur\.br|tv\.br|vet\.br|zlg\.br|br|ab\.ca|bc\.ca|mb\.ca|nb\.ca|nf\.ca|ns\.ca|nt\.ca|on\.ca|pe\.ca|qc\.ca|sk\.ca|yk\.ca|ca|cc|ac\.cn|com\.cn|edu\.cn|gov\.cn|org\.cn|bj\.cn|sh\.cn|tj\.cn|cq\.cn|he\.cn|nm\.cn|ln\.cn|jl\.cn|hl\.cn|js\.cn|zj\.cn|ah\.cn|gd\.cn|gx\.cn|hi\.cn|sc\.cn|gz\.cn|yn\.cn|xz\.cn|sn\.cn|gs\.cn|qh\.cn|nx\.cn|xj\.cn|tw\.cn|hk\.cn|mo\.cn|cn|cx|cz|de|dk|fo|com\.ec|tm\.fr|com\.fr|asso\.fr|presse\.fr|fr|gf|gs|co\.il|net\.il|ac\.il|k12\.il|gov\.il|muni\.il|ac\.in|co\.in|org\.in|ernet\.in|gov\.in|net\.in|res\.in|is|it|ac\.jp|co\.jp|go\.jp|or\.jp|ne\.jp|ac\.kr|co\.kr|go\.kr|ne\.kr|nm\.kr|or\.kr|li|lt|lu|asso\.mc|tm\.mc|com\.mm|org\.mm|net\.mm|edu\.mm|gov\.mm|ms|nl|no|nu|pl|ro|org\.ro|store\.ro|tm\.ro|firm\.ro|www\.ro|arts\.ro|rec\.ro|info\.ro|nom\.ro|nt\.ro|se|si|com\.sg|org\.sg|net\.sg|gov\.sg|sk|st|tf|ac\.th|co\.th|go\.th|mi\.th|net\.th|or\.th|tm|to|com\.tr|edu\.tr|gov\.tr|k12\.tr|net\.tr|org\.tr|com\.tw|org\.tw|net\.tw|ac\.uk|uk\.com|uk\.net|gb\.com|gb\.net|vg|sh|kz|ch|info|ua|gov|name|pro|ie|hk|com\.hk|org\.hk|net\.hk|edu\.hk|us|tk|cd|by|ad|lv|eu\.lv|bz|es|jp|cl|ag|mobi|eu|co\.nz|org\.nz|net\.nz|maori\.nz|iwi\.nz|io|la|md|sc|sg|vc|tw|travel|my|se|tv|pt|com\.pt|edu\.pt|asia|fi|com\.ve|net\.ve|fi|org\.ve|web\.ve|info\.ve|co\.ve|tel|im|gr|ru|net\.ru|org\.ru|hr|com\.hr|ly|xyz)$/);
} //解码


function _d(s) {
  return decodeURIComponent(s.replace(/\+/g, ' '));
}

function _i(arg, str) {
  var sptr = arg.charAt(0),
      split = str.split(sptr);

  if (sptr === arg) {
    return split;
  }

  arg = _babel_runtime_corejs2_core_js_parse_int__WEBPACK_IMPORTED_MODULE_0___default()(arg.substring(1), 10);
  return split[arg < 0 ? split.length + arg : arg - 1];
}

function _f(arg, str) {
  var sptr = arg.charAt(0),
      split = str.split('&'),
      field = [],
      params = {},
      tmp = [],
      arg2 = arg.substring(1);

  for (var i = 0, ii = split.length; i < ii; i++) {
    field = split[i].match(/(.*?)=(.*)/);

    if (!field) {
      field = [split[i], split[i], ''];
    }

    if (field[1].replace(/\s/g, '') !== '') {
      field[2] = _d(field[2] || ''); // If we have a match just return it right away.

      if (arg2 === field[1]) {
        return field[2];
      } // Check for array pattern.


      tmp = field[1].match(/(.*)\[([0-9]+)\]/);

      if (tmp) {
        params[tmp[1]] = params[tmp[1]] || [];
        params[tmp[1]][tmp[2]] = field[2];
      } else {
        params[field[1]] = field[2];
      }
    }
  }

  if (sptr === arg) {
    return params;
  }

  return params[arg2];
} //解析url信息


function parseUrl(arg, url) {
  var _l = {},
      tmp,
      tmp2;

  if (arg === 'tld?') {
    return _t();
  }

  url = url || window.location.toString();

  if (!arg) {
    return url;
  }

  arg = arg.toString();

  if (tmp = url.match(/^mailto:([^\/].+)/)) {
    _l.protocol = 'mailto';
    _l.email = tmp[1];
  } else {
    // Ignore Hashbangs.
    if (tmp = url.match(/(.*?)\/#\!(.*)/)) {
      url = tmp[1] + tmp[2];
    } // Hash.


    if (tmp = url.match(/(.*?)#(.*)/)) {
      _l.hash = tmp[2];
      url = tmp[1];
    } // Return hash parts.


    if (_l.hash && arg.match(/^#/)) {
      return _f(arg, _l.hash);
    } // Query


    if (tmp = url.match(/(.*?)\?(.*)/)) {
      _l.query = tmp[2];
      url = tmp[1];
    } // Return query parts.


    if (_l.query && arg.match(/^\?/)) {
      return _f(arg, _l.query);
    } // Protocol.


    if (tmp = url.match(/(.*?)\:?\/\/(.*)/)) {
      _l.protocol = tmp[1].toLowerCase();
      url = tmp[2];
    } // Path.


    if (tmp = url.match(/(.*?)(\/.*)/)) {
      _l.path = tmp[2];
      url = tmp[1];
    } // Clean up path.


    _l.path = (_l.path || '').replace(/^([^\/])/, '/$1').replace(/\/$/, ''); // Return path parts.

    if (arg.match(/^[\-0-9]+$/)) {
      arg = arg.replace(/^([^\/])/, '/$1');
    }

    if (arg.match(/^\//)) {
      return _i(arg, _l.path.substring(1));
    } // File.


    tmp = _i('/-1', _l.path.substring(1));

    if (tmp && (tmp = tmp.match(/(.*?)\.(.*)/))) {
      _l.file = tmp[0];
      _l.filename = tmp[1];
      _l.fileext = tmp[2];
    } // Port.


    if (tmp = url.match(/(.*)\:([0-9]+)$/)) {
      _l.port = tmp[2];
      url = tmp[1];
    } // Auth.


    if (tmp = url.match(/(.*?)@(.*)/)) {
      _l.auth = tmp[1];
      url = tmp[2];
    } // User and pass.


    if (_l.auth) {
      tmp = _l.auth.match(/(.*)\:(.*)/);
      _l.user = tmp ? tmp[1] : _l.auth;
      _l.pass = tmp ? tmp[2] : undefined;
    } // Hostname.


    _l.hostname = url.toLowerCase(); // Return hostname parts.

    if (arg.charAt(0) === '.') {
      return _i(arg, _l.hostname);
    } // Domain, tld and sub domain.


    if (_t()) {
      tmp = _l.hostname.match(_t());

      if (tmp) {
        _l.tld = tmp[3];
        _l.domain = tmp[2] ? tmp[2] + '.' + tmp[3] : undefined;
        _l.sub = tmp[1] || undefined;
      }
    } // Set port and protocol defaults if not set.


    _l.port = _l.port || (_l.protocol === 'https' ? '443' : '80');
    _l.protocol = _l.protocol || (_l.port === '443' ? 'https' : 'http');
  } // Return arg.


  if (arg in _l) {
    return _l[arg];
  } // Return everything.


  if (arg === '{}') {
    return _l;
  } // Default to undefined for no match.


  return undefined;
} //添加或者更新uri中的参数

function updateParam(key, value, uri) {
  // Use window URL if no query string is provided
  if (!uri) {
    uri = window.location.href;
  } // Create a dummy element to parse the URI with


  var a = document.createElement('a'),
      // match the key, optional square bracktes, an equals sign or end of string, the optional value
  reg_ex = new RegExp(key + '((?:\\[[^\\]]*\\])?)(=|$)(.*)'),
      // Setup some additional variables
  qs,
      qs_len,
      key_found = false; // Use the JS API to parse the URI

  a.href = uri; // If the URI doesn't have a query string, add it and return

  if (!a.search) {
    a.search = '?' + key + '=' + value;
    return a.href;
  } // Split the query string by ampersands


  qs = a.search.replace(/^\?/, '').split(/&(?:amp;)?/);
  qs_len = qs.length; // Loop through each query string part

  while (qs_len > 0) {
    qs_len--; // Check if the current part matches our key

    if (reg_ex.test(qs[qs_len])) {
      // Replace the current value
      qs[qs_len] = qs[qs_len].replace(reg_ex, key + '$1') + '=' + value;
      key_found = true;
    }
  } // If we haven't replaced any occurences above, add the new parameter and value


  if (!key_found) {
    qs.push(key + '=' + value);
  } // Set the new query string


  a.search = '?' + qs.join('&');
  return a.href;
} //获取地址hash值

function getUrlHash(query) {
  query = query.replace(/[\[]/, '\\\[').replace(/[\]]/, '\\\]');
  var expr = '[\\?#&]' + query + '=([^&#]*)';
  var regex = new RegExp(expr);
  var results = regex.exec(window.location.href);

  if (results !== null) {
    return results[1];
  } else {
    return false;
  }
} //url中删除指定参数

function removeParam(sourceURL) {
  var rtn = decodeURIComponent(sourceURL).split('?')[0],
      param,
      params_arr = [],
      queryString = sourceURL.indexOf('?') !== -1 ? sourceURL.split('?')[1] : '';

  if (queryString !== '') {
    params_arr = queryString.split('&');

    for (var i = params_arr.length - 1; i >= 0; i -= 1) {
      param = params_arr[i].split('=')[0];

      for (var x = arguments.length - 1; x >= 1; x -= 1) {
        if (param === arguments[x]) {
          params_arr.splice(i, 1);
        }
      }
    }

    rtn = rtn + '?' + params_arr.join('&');
  }

  return rtn;
}
function isUrl(url) {
  return urlRegex.test(url);
}
/* harmony default export */ __webpack_exports__["default"] = ({
  urlRegex: urlRegex,
  urlHash: urlHash,
  urlParams: urlParams,
  updateParam: updateParam,
  getUrlHash: getUrlHash,
  removeParam: removeParam,
  isUrl: isUrl,
  parseUrl: parseUrl
});

/***/ })

/******/ });